<template>
  <el-select
    :value="value"
    size="small"
    @change="handleChange"
    placeholder="请选择区域"
  >
    <el-option :key="0" label="不限" v-if="search" :value="0"></el-option>
    <el-option
      v-for="item in lists"
      :key="item.id"
      :label="item.name"
      :value="item.id"
    ></el-option>
  </el-select>
</template>

<script>
import { regionList } from '@/service/getData'

export default {
  props: {
    value: '',
    search: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      lists: [],
    }
  },

  created() {
    this.getList()
  },
  methods: {
    async getList() {
      let res = await regionList({
        filter_auth: true,
      })
      if (res.code == 0) {
        this.lists = res.data.list
      }
    },
    handleChange(e) {
      this.$emit('input', e)
    },
  },
}
</script>
<style>
.select-err .el-input__inner {
  border-color: #f56c6c;
}
</style>